import { Create, SimpleForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { ColorPicker } from '../../components/ColorPicker';

const initialValues = {
  title: '',
  bgColor: '',
  fgColor: '',
};
export const TagCreate = (props: unknown) => (
  <Create {...props} title={<CustomTitle />}>
    <SimpleForm redirect={false} defaultValues={initialValues}>
      <TextInput source="title" />
      <ColorPicker source="bgColor" label="Background color" help="opcional, color de fondo de la celda en el grid" />
      <ColorPicker source="fgColor" label="Foreground color" help="opcional, color de texto de la celda en el grid" />
    </SimpleForm>
  </Create>
);
